import '../styles/Settings.css';
import { useEffect, useState } from 'react';
import RelativeSvgLoader from '../common/components/RelativeSvgLoader';
import YesNoPopup from '../common/components/YesNoPopup'; // Import the popup component
import Success from '../common/components/SuccessMessage';
import Checkbox from '@mui/material/Checkbox'; // Import Material-UI Checkbox
import FormControlLabel from '@mui/material/FormControlLabel'; // For label alignment
import AuthData from '../common/AuthData';
import Fetch  from '../services/fetchService';
import Post from '../services/postService';
import { SETTINGS_API } from '../common/ResourcePaths'; // Import the constants

function Maintanance() {
    const [showPopup, setShowPopup] = useState(false);
    const [modified, setModified] = useState(false);
    const [successTimer, setSuccessTimer] = useState(10);
    const [success, setSuccess] = useState(false);
    const [loader, setLoader] = useState(false);
    const [maintenance, setMaintenance] = useState(false);
    const [maintenanceDuration, setMaintenanceDuration] = useState('');
    const [noTimeLimit, setNoTimeLimit] = useState(false);
    const defaultMaintenanceDuration = '90'; // Default duration in minutes

    useEffect(() => {
        const getMaintenance = async () => {
            try {
                setLoader(true);
                const authData = AuthData.getAuthData();
                const url = `${authData.appFunctionUrl}${SETTINGS_API}/maintanance?code=${authData.azureFunctionKey}`;
                const response = await Fetch(url, authData.clientId);
                setMaintenance(response.turnOn);
                setMaintenanceDuration(response.minutes === 0 ? '' : response.minutes.toString());
                setNoTimeLimit(response.minutes === 0);
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoader(false);
            }
        };

        getMaintenance();
    }, []);

    const onMaintananceChange = (e) => {
        const value = e.target.value;
        setMaintenanceDuration(value);
        setModified(true);
    }

    const handleMaintananceChangeNoLimit = (e) => {
        setModified(true);
        setNoTimeLimit(e.target.checked);
        if(e.target.checked) {
            setMaintenanceDuration('');
            return;
        }
        setMaintenanceDuration(defaultMaintenanceDuration);
    }

    const handleMaintenanceChange = (e) => {
        setModified(true);
        setMaintenance(e.target.checked);
        if(!e.target.checked) {
            setMaintenanceDuration('');
            setNoTimeLimit(false);
            return;
        }

        setMaintenanceDuration(defaultMaintenanceDuration);
    };

    const reset = () => {
        setMaintenance(false);
        setMaintenanceDuration('');
        setModified(true);
    };

    const handleSave = async (e) => {
        e.preventDefault();
        setLoader(true);

        const authData = AuthData.getAuthData();
        const url = `${authData.appFunctionUrl}${SETTINGS_API}/maintenance?code=${authData.azureFunctionKey}`; // Use the constant here
        const data = {
            turnOn: maintenance,
            minutes: maintenanceDuration ? parseInt(maintenanceDuration) : 0
        };
        const response = await Post(url,authData.clientId, data);
        setMaintenance(response.turnOn);
        setMaintenanceDuration(response.minutes === 0 ? '' : response.minutes.toString());
        setSuccess(true);
        setSuccessTimer(10);
        const timerInterval = setInterval(() => {
            setSuccessTimer((prev) => {
                if (prev <= 1) {
                    clearInterval(timerInterval);
                    setSuccess(false);
                    return 0;
                }
                return prev - 1;
                });
            }, 1000);
        setLoader(false);
        setModified(false);
    };

    const handleYes = () => {
        setShowPopup(false);
        reset();
    };

    const handleNo = () => {
        setShowPopup(false);
    };

    return (
        <div className="container" style={{ position: 'relative' }}>
            {loader && <RelativeSvgLoader />}
            <div className="form-wrapper" style={{ opacity: loader ? 0.3 : 1 }}>
                {success && (
                    <Success
                        message={`Data saved successfully! (${successTimer}s)`}
                    />
                )}
                    <form
                        onSubmit={(e) => handleSave(e)}
                    >
                        <div className="form-group">
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={maintenance}
                                        onChange={(e) => handleMaintenanceChange(e)}
                                        color="primary"
                                    />
                                }
                                label="Put site in maintenance mode"
                            />
                        </div>
                        <div className="form-group">
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={noTimeLimit}
                                        onChange={(e) => handleMaintananceChangeNoLimit(e)}
                                        color="primary"
                                        disabled={!maintenance} 
                                    />
                                }
                                label="No automatic end time"
                            />
                        </div>
                        <div className="form-grid">
                            <label className='form-label' htmlFor="maintenanceDuration">Duration in minutes:</label>
                            <input
                                type="number"
                                id="maintenanceDuration"
                                name="maintenanceDuration"
                                min="1"
                                value={maintenanceDuration}
                                disabled={!maintenance || noTimeLimit}
                                onChange={(e) => onMaintananceChange(e)}
                                className="input-field"
                            />
                        </div>
                        <div className="form-footer">
                            <button
                                type="submit"
                                disabled={!modified}
                                className="submit-button">
                                Save
                            </button>
                            <button
                                type="button"
                                className="clear-data-button"
                                style={{ marginLeft: '10px' }}
                                onClick={() => setShowPopup(true)}>
                                Reset
                            </button>
                        </div>
                    </form>
                    {showPopup && (
                        <YesNoPopup handleYes={handleYes} handleNo={handleNo} />
                    )}
                </div>
        </div>
    );
}

export default Maintanance;